import React, {Component} from 'react';

import {TableLayout} from '../Menu/Stock/containers/Layout';

import SearchBar from './Layouts/SeachBar';
import Dialog from '../../commonModules/interface/Dialog';
import InputText from '../../commonModules/interface/form-input-inline';
import {connect} from 'react-redux';

import {disableSubscription, changeStockManagementSubscription} from '../../../../../jsx/actions/subscriptionAction'
import { getPaygClients } from '../../../../../jsx/actions/clientAction';

import NewSubscription from '../Menu/module/paygoNewSubscription';
import {isEmpty} from 'lodash'
import Currency from '../../commonModules/Currency';

import { Table, TableBody, TableRow, TableCell, Grid, Button, TableHead, Card, Box, TableContainer } from '@material-ui/core';
import { TabletMacRounded, LocalShippingRounded, FilterRounded } from '@material-ui/icons';
import SubscriptionUpdateForms from './Subscription/SubscriptionUpdateForms';
import CardButton from '../../commonModules/interface/CardButton';
import DeleteDialog from '../../commonModules/interface/DeleteDialog';
import SearchBarAction from './Layouts/SearchBarAction';
import PageAdmin from './Layouts/PageAdmin';
import { toast } from 'react-toastify';

class SubscriptionsList extends Component {
    state = {
        form: "",
        new: false,
        list: [],
        mdpAdmin: '',
        errors: {
            mdpAdmin: ''
        },
        dialogDelete: false,
        deleteSub: {},
        openDialog: false,
        currentSub: {}
    }
    componentDidMount = async () => {
        const { SUBSCRIPTIONS, STATE } = this.props;
        console.log('====================================');
        console.log(STATE.paygClients);
        console.log('====================================');
        if (isEmpty(SUBSCRIPTIONS)) {
            await this.props.fetchSubscriptions()
        }
        if(!STATE.paygClients.fetched){
            console.log('================FETCHIING CLIENTS====================');
            console.log('====================================');

            // important action to get Subscriptions stats /!\
            await this.props.getClients() // not working
        }
        this.filterList()
    }
    filterList = (list) => {
        if (!list) {
            if (!isEmpty(this.props.SUBSCRIPTIONS)) {
                list = Object.keys(this.props.SUBSCRIPTIONS)
            } else {
                list = []
            }
        }
        this.setState({list})
    }
    handleChange = (e) => {
        const field = e.target.name
        const value = e.target.value
        this.setState({[field]: value})
    }
    disableSubscription = async (sub) => {
        console.log('[INFO] disableSubscription.jsx');
        this.props.disableSubscription(sub)
    }
    changeStockManagement = async (sub) => {
        console.log('[INFO] changeStockManagement');
        await this.props.changeStockManagementSubscription(sub)
        console.log('====================================');
        console.log(this.props.STATE);
        console.log(this.props.STATE.subscriptions);
        console.log('====================================');
        if (this.props.STATE.subscriptions.error){
            console.log("ERROR", this.props.STATE.subscriptions.error);
            toast.error(  this.props.STATE.subscriptions.error)
        } else {
            console.log("SUCCESS", this.props.STATE.subscriptions);
            toast.info( "Abonnement modifié avec succès")
        }   
    }
    deleteSubscription = async () => {
        console.log('[INFO] delete subscriptionsList.jsx');
        // Password verification is now handled by the backend
        // Note: For subscriptions, password is optional (backend checks only if provided)
        await this.props.deleteSubscription(this.state.deleteSub)

        if (this.props.STATE.subscriptions.error) {
            console.log("[ERROR] delete abo", this.props.STATE.subscriptions.error);
            const errorMsg = this.props.STATE.subscriptions.error;
            if (typeof errorMsg === 'string' && errorMsg.includes("Mot de passe")) {
                toast.error(errorMsg);
            } else {
                toast.error("Un Problème est survenu");
            }
        } else {
            //success
            toast.success("Abonnement supprimé avec succès")
            this.setState({
                dialogDelete: false,
                deleteSub: {}
            })
        }
    }

    render() {
        const {SUBSCRIPTIONS, STATS_SUB} = this.props;
        const {currentSub, openDialog, dialogDelete, deleteSub} = this.state;
        let subscribed_list = isEmpty(STATS_SUB) ? null : Object.keys(STATS_SUB)

        console.log('=============[PROPS]=======================');
        console.log(this.props);
        console.log('====================================');
        return (
            <PageAdmin title="Abonnements">
                {this.state.new && 
                    <NewSubscription
                        popupState={"overlay"}
                        onCloseOverlay={() => this.setState({new: false})}
                    />
                }
                {dialogDelete && 
                    <DeleteDialog
                        title={"l'abonnement \"" + deleteSub.name + "\""}
                        // text={deleteForm}
                        handleSubmit={this.deleteSubscription}
                        // submitTitle="Supprimer"
                        open={true}
                        close={() => this.setState({dialogDelete: false, deleteSub: {}})}
                    />
                }
                {openDialog && 
                <Dialog
                    title={currentSub.name}
                    block={true}
                    close={() => this.setState({openDialog: false, currentSub: {}, form: ""})}
                    maxWidth="md"
                >
                    <Grid container spacing={2}>
                        <Grid item xs={12} sm={8}>
                            <TableContainer>
                                <Table>
                                    <TableBody className="text-left">
                                        <TableRow>
                                            <TableCell colSpan={2} >Prix Total : </TableCell>
                                            <TableCell colSpan={2}><Currency value={currentSub.total} /></TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell colSpan={2} >Deposit : </TableCell>
                                            <TableCell colSpan={2}><Currency value={currentSub.deposit} /> pour {currentSub.depositDay} jours </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell colSpan={2} >Stock : </TableCell>
                                            <TableCell colSpan={2}>{currentSub.stocklink == "nolink" ? "Non" : "Oui" }</TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell colSpan={2} >Déblocage : </TableCell>
                                            <TableCell colSpan={2}>{currentSub.unlockthirdParty }</TableCell>
                                        </TableRow>
                                        <TableRow><TableCell colSpan={4}></TableCell></TableRow>
                                    </TableBody>
                                </Table>
                            </TableContainer>
                            <TableContainer>
                                <Table>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell colSpan={4} style={{textAlign: "center"}}>Grille de Prix (FCFA)</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        <TableRow>
                                            <TableCell component="th">Nombre</TableCell>
                                            <TableCell component="th">Jour</TableCell>
                                            <TableCell component="th">Mois</TableCell>
                                            <TableCell component="th">Année</TableCell>
                                        </TableRow>
                                        {!isEmpty(currentSub.day.timePrice) && currentSub.day.timePrice.map(item => 
                                            <TableRow>
                                                <TableCell>{item.Day + item.Month * 30 + item.Year * 365}</TableCell>
                                                <TableCell>{item.Day === 1 && item.Price}</TableCell>
                                                <TableCell>{(item.Month === 1 || item.Day === 31 || item.Day === 30) && item.Price}</TableCell>
                                                <TableCell>{item.Year === 1 && item.Price}</TableCell>
                                            </TableRow>
                                        )}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Grid>
                        <Grid item xs={12} sm={4}>
                            {/* <Box p={1}>
                                <div className="card card-button"
                                    onClick={() => this.state.form === "updateFORMS" ?
                                        this.setState({form: ""}) : 
                                        this.setState({form: "updateFORMS"})
                                    }
                                    title="Changer Questionnaire"
                                >
                                    <div>
                                        <TabletMacRounded color="primary"/>
                                    </div>
                                    <h4>Changer Questionnaire</h4>
                                </div> */}
                                {this.state.form === "updateFORMS" && 
                                    <SubscriptionUpdateForms
                                        {...this.state}
                                        subscriptionID={currentSub.id}
                                        handleClose={() => this.setState({form: ""}) }
                                    />
                                }
                                <CardButton
                                    icon={<TabletMacRounded color="primary"/>}
                                    title="Changer Questionnaire"
                                    action={() => this.state.form === "updateFORMS" ?
                                        this.setState({form: ""}) : 
                                        this.setState({form: "updateFORMS"})
                                    }
                                />
                                
                                <CardButton
                                    icon={<LocalShippingRounded color="secondary"/>}
                                    title="Ajouter option stock"
                                    action={() => this.changeStockManagement(currentSub)}
                                    disabled={this.props.STATE.subscriptions.fetching}
                                />
                                {/* <div
                                    className="card card-button"
                                    onClick={() => this.changeStockManagement(currentSub)}
                                    title="Ajouter option stock">
                                    <div>
                                        <LocalShippingRounded color="secondary" />
                                    </div>
                                    <h4>Ajouter option stock</h4>
                                </div>
                            </Box>   */}
                        </Grid>
                    </Grid>
                </Dialog>
                }

                {/* <h3>Abonnements</h3> */}
                {/* <Grid container spacing={2} >
                    <Grid item sm={3} xs={12}>
                        <Button 
                            variant="contained"
                            color="primary"
                            onClick={()=>
                                this.setState({ new: true })
                            }>Nouveau</Button>
                    </Grid>
                    <Grid item sm={9} xs={12}>
                    </Grid>
                        
                </Grid> */}
                <SearchBarAction list={ SUBSCRIPTIONS } filterList={this.filterList}  action={()=> this.setState({ new: true }) } name="searchCustom"/>
                
                <TableLayout>
                    <TableHead>
                        <TableRow>
                            <TableCell>Name</TableCell>
                            <TableCell>Type</TableCell>
                            <TableCell>Mensualite</TableCell>
                            <TableCell>Prix Total</TableCell>
                            <TableCell>Options</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {!isEmpty(SUBSCRIPTIONS) && this.state.list.map(ID => {
                                let subscription = SUBSCRIPTIONS[ID]
                                return (
                                    <TableRow key={ID}>
                                        <TableCell onClick={() => this.setState({openDialog: true, currentSub: subscription})}>{subscription.name}</TableCell>
                                        <TableCell onClick={() => this.setState({openDialog: true, currentSub: subscription})}>{subscription.type}</TableCell>
                                        <TableCell onClick={() => this.setState({openDialog: true, currentSub: subscription})}>{subscription.mensualite}</TableCell>
                                        <TableCell onClick={() => this.setState({openDialog: true, currentSub: subscription})}>{subscription.total}</TableCell>
                                        <TableCell>
                                            {subscribed_list && subscribed_list.includes(ID) ? 
                                                <Button
                                                    variant="contained"
                                                    color={subscription.status === "Disabled"
                                                    ? "primary"
                                                    : "secondary"}
                                                    onClick={() => this.disableSubscription(subscription)}
                                                >
                                                    {subscription.status === "Disabled"
                                                    ? "Enable"
                                                    : "Disable"}
                                                </Button>
                                                : <Button
                                                    variant="contained"
                                                    color="error"
                                                    onClick={() => this.setState({
                                                        deleteSub: subscription, 
                                                        dialogDelete: true})
                                                    }
                                                >
                                                    Supprimer
                                                </Button>
                                            }
                                        </TableCell>
                                    </TableRow>
                                )
                            })
                        }

                    </TableBody>
                </TableLayout>
            </PageAdmin>
        );
    }
}

const mapStateToProps = (state) => ({
});
const mapDispatchToProps = (dispatch) => ({
    disableSubscription: (info) => dispatch(disableSubscription(info)),
    changeStockManagementSubscription: (info) => dispatch(changeStockManagementSubscription(info)),
    getClients: () => dispatch(getPaygClients()),

});

export default connect(mapStateToProps, mapDispatchToProps)(SubscriptionsList);
